module.exports = __webpack_public_path__ + "static/media/icon-wetdoorlocked.2837a9c1.svg";